import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist' // https://www.npmjs.com/package/vuex-persist
Vue.use(Vuex)


//import { bus, app, apiUrl } from '../main'
//import UpdateConfigStore from './updateConfigStore.js'
import UserStore from './user.js'
import BetriebeStore from './betriebe.js'
import BeziehungenStore from './beziehungen.js'
import NavigationStore from './navigation.js'
import NewsStore from './news.js'
import SearchStore from './search.js'
import MengenStore from './mengen.js'
import AnalysenStore from './analysen.js'
import DatenpaketeStore from './datenpakete.js'
import EinladungenStore from './einladungen.js'
import DokumenteStore from './dokumente.js'
import ZulagenStore from './zulagen.js'

let vuexLocal= {}

/* development alles in Cache = weniger Requests */
vuexLocal = new VuexPersistence({
	storage: window.localStorage
})


export default new Vuex.Store({
	modules: {
		userStore: UserStore,
		betriebeStore: BetriebeStore,
		beziehungenStore: BeziehungenStore,
		navigationStore: NavigationStore,
		newsStore: NewsStore,
		searchStore: SearchStore,
		mengenStore: MengenStore,
		analysenStore: AnalysenStore,
		datenpaketeStore: DatenpaketeStore,
		dokumenteStore: DokumenteStore,
		einladungenStore: EinladungenStore,
		zulagenStore: ZulagenStore,
	},
	state: {},
	// call actions from outside as action: this.$store.dispatch('LOAD_accesspoints')
	actions: {},
	//call with this.$store.commit('setMainStationConfig',{"Ip": "192.168.100.150","Port": "80","Status": "DISCONNECTED"})
	mutations: {},
	//plugins: [(new VuexPersistence()).plugin]
	plugins: [vuexLocal.plugin]
})